module.exports = __webpack_public_path__ + "d6331231723fd9048f91731761a1c446.ttf";